import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { getPlatformGrowth } from '@services/api';
import AnimatedNumber from './AnimatedNumber';

interface PlatformGrowthData {
  numberOfStylists: number;
  stylistGrowthSinceLastWeek?: number;
  numberOfUsers?: number;
  userGrowthSinceLastWeek?: number;
}

const PlatformGrowth: React.FC = () => {
  const { t } = useTranslation();
  const [platformGrowth, setPlatformGrowth] = useState<PlatformGrowthData | null>(null);
  const [isGrowthSectionVisible, setIsGrowthSectionVisible] = useState<boolean>(false);
  const growthSectionRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const fetchGrowthData = async (): Promise<void> => {
      try {
        const data = await getPlatformGrowth();
        setPlatformGrowth(data as PlatformGrowthData);
      } catch (error) {
        console.error('Error fetching platform growth data', error);
      }
    };
    fetchGrowthData();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsGrowthSectionVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    const currentRef = growthSectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [platformGrowth]);

  if (!platformGrowth) {
    return null;
  }

  return (
    <section className="platform-growth" ref={growthSectionRef}>
      <div className="metric-item">
        <span className="metric-label">{t('home.stylistsOnboarded')}:</span>
        <strong className="metric-value">
          <AnimatedNumber number={platformGrowth.numberOfStylists} startAnimation={isGrowthSectionVisible} />
        </strong>
        <span className="growth-number">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="growth-icon"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>
          <AnimatedNumber number={platformGrowth.stylistGrowthSinceLastWeek || 0} startAnimation={isGrowthSectionVisible} />
        </span>
      </div>
      {/* Temporarily hidden - Total Users Count */}
      {/* <div className="metric-separator" />
      <div className="metric-item">
        <span className="metric-label">{t('home.usersCount')}:</span>
        <strong className="metric-value">
          <AnimatedNumber number={platformGrowth.numberOfUsers} startAnimation={isGrowthSectionVisible} />
        </strong>
        <span className="growth-number">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="growth-icon"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>
          <AnimatedNumber number={platformGrowth.userGrowthSinceLastWeek || 0} startAnimation={isGrowthSectionVisible} />
        </span>
      </div> */}
    </section>
  );
};

export default PlatformGrowth;
